import React from 'react';

const RecentlyReviewed = ({
  color = 'var(--color-primary)',
  width = 25,
  height = 21,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 25 21"
  >
    <path
      fill="none"
      fillRule="evenodd"
      stroke={color}
      strokeLinejoin="round"
      strokeWidth="1.4"
      d="M3.4 1h18.2C22.925 1 24 2.075 24 3.4v11.348c0 1.326-1.075 2.4-2.4 2.4h-8.778c-.941 0-1.796.55-2.185 1.407L9.98 20h0l-.68-1.463c-.393-.847-1.242-1.389-2.176-1.389H3.4c-1.325 0-2.4-1.074-2.4-2.4V3.4C1 2.075 2.075 1 3.4 1z"
    />
  </svg>
);

export default RecentlyReviewed;
